<svg-icon name="{{ name }}"></svg-icon>
